/*
  * check for options object being supported
  *
  * results in a global window variable being set
  *
*/
window.passiveSupported = false;

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function () {
      window.passiveSupported = true;
    }
  });
  window.addEventListener("testPassive", null, opts);
  window.removeEventListener("testPassive", null, opts);
} catch (e) { console.log(e) }